import { FC } from 'react'
import { SampleDetailed } from '../types'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { useTranslation } from 'react-i18next'
import { SharedModalContent } from 'views/components/SharedModal'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'

type Props = {
  onClose: () => void
  refetch: refetchFunc
  sample: SampleDetailed
}
export const SampleResumeModal: FC<Props> = ({ onClose, refetch, sample }) => {
  const { t } = useTranslation(['samples'])

  const [progress, resumeSampleRequest] = useAProgress(
    () => apiClient.put(endpoints.sampleRequestResume(sample.sample_request_id.toString())),
    {
      eventName: 'resumeSample',
      analyticsPayload: {
        id: sample.id.toString(),
      },
      onSuccess: async () => {
        await refetch()
        onClose()
      },
    },
  )
  return (
    <ResponsiveModal
      id="resumeSampleModal"
      title={t('resume')}
      progress={progress}
      onConfirm={resumeSampleRequest}
      onClose={onClose}
      size="small"
    >
      <SharedModalContent></SharedModalContent>
    </ResponsiveModal>
  )
}
